import React, { createRef, FC, useEffect, useRef, useState, useReducer } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { FormInstance } from 'antd/es/form/Form'
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'
import {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    Button, DatePicker, Form, Input, Space, Typography, notification, Spin, Upload, List, TimePicker,Radio
} from 'antd'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { CheckCircleOutlined, SmileOutlined, UploadOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons'
import 'moment/locale/zh-cn'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import locale from 'antd/es/date-picker/locale/zh_CN'
import moment from 'moment'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { IAppState } from '@/store/reducers'
import { getWorkgroup } from '@/store/actions/tableEdit.action'
import type { Descendant } from 'slate'
import DSlate, { DefaultPlugin } from '@dslate/dslate'
import type { DSlateRef } from '@dslate/core'
import { ConfigProvider, defaultConfig } from '@dslate/core'
import { debounce, downloadFile, getUuid } from '@/utils/util'
import { handleTrim, serialize } from '@/pages/table2Mana/table2Edit'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { addOnlineReview, delFile, editOnlineReview, getFile, getOnlineReviewById, getWorkDateDiff, uploadFile } from '@/services/progress.service'
import { IAddOnlineReviewData } from '@/store/models/process.model'
import { UploadAPI } from '@/config'
import _ from 'lodash'
import SelectBU from '@/components/selectBU'
import { IBu } from '@/store/models/auth.model'
import Nav from '@/components/nav'

const plugs = { ...DefaultPlugin }
// 删除图片工具
Reflect.deleteProperty(plugs, 'ImgPlugin')


const ShowSelectTechListPop = 'showSelectTechListPop'
const HideSelectTechListPop = 'hideSelectTechListPop'
const SetSelectTechList = 'setSelectTechListPop'
const DelSelectTechList = 'delSelectTechList'
const SetReviewType = 'setReviewType'

const initialState = {
    showSelectTechListPop: false,
    allSelectTechObj: [],
    reviewType: null,
}
const reducer = (state: any, action: { type: string, payload?: any }) => {
    const { type, payload } = action
    let arr = []
    switch (type) {
        case ShowSelectTechListPop:
            return {
                ...state,
                showSelectTechListPop: true
            }
        case HideSelectTechListPop:
            return {
                ...state,
                showSelectTechListPop: false,
            }
        case SetSelectTechList:
            return {
                ...state,
                showSelectTechListPop: false,
                allSelectTechObj: payload
            }
        case DelSelectTechList:
            arr = state.allSelectTechObj.filter((item: any) => item.techProject.id !== payload.techProject.id)
            return {
                ...state,
                allSelectTechObj: [...arr]
            }
        case SetReviewType:
            return {
                ...state,
                reviewType: payload
            }
    }
}

const ReviewMoreApply: FC = () => {
    const history = useHistory()
    const locationObj = useLocation()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const { Text } = Typography

    const [loaded, setloaded] = useState(false)
    const [formObj, setFormObj] = useState<IAddOnlineReviewData & {parentId?: string; id?: number} | null>(null)
    const [fileList, setFileList] = useState<(UploadFile & {
        url?: string
        fileId?: number
        status?: string
    })[]>([])
    const [fileIds, setFileIds] = useState<number[]>([])
    const [uploading, setUploading] = useState(false)
    const [isCommunicate, setIsCommunicate] = useState(false)
    // 当前选择的是 devSubject | devCostAttr
    const [curSelectType, setCurSelectType] = useState('')
    // 时间选择起始
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [selectStartDate, setSelectStartDate] = useState<any>(null)
    // 开发责任主体
    const [devSubject, setDevSubject] = useState<IBu[]>([])
    // 开发费用归属
    const [devCostAttr, setDevCostAttr] = useState<IBu[]>([])
    const [loading, setLoading] = useState(false)
    // 富文本编辑器key
    // 提案申请相关性反馈
    const [editorKey, setEditorKey] = useState('1')
    const [reviewDateKey, setReviewDateKey] = useState('1')
    // 富文本编辑器 内容
    const [descriptionValue, setDescriptionValue] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    // 选择BU或CT清单
    const [showSelectBu, setShowSelectBu] = useState(false)
    const [showSelectBu2, setShowSelectBu2] = useState(false)
    const [stateR, dispatchR] = useReducer(reducer, initialState)
    const { allSelectTechObj, reviewType } = stateR
    
    const formRef = createRef<FormInstance>()
    const [form] = Form.useForm()
    // 富文本编辑器
    const editorRef = useRef<DSlateRef>(null)
    const uploadFileLs = useRef<RcFile[]>([])
    const fileListRef = useRef<(UploadFile & {
        url?: string
        fileId?: number
        status?: string
        deleteState?: boolean
    })[]>([])
    // 评审类型
    const approvalType = [
        { id: 1, label: t('technicalPlan') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 2, label: t('technicalDefineAndResearchTaskBook') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 3, label: t('technicalAchievementDelivery') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 4, label: t('buTMTApproveTech') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
    ]

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 10 },
    }
    const tailLayout = {
        wrapperCol: { offset: 6, span: 10 },
    }
    const handleUpload = async (files: UploadFile[]) => {
        const formData = new FormData()
        if(files.length > 10){
            setUploading(false)
            setFileList([...fileList])
            dispatch(requestFail('Files Must less 10!'))
            return 
        }
        try {
            files.forEach(file => {
                if(file.size && file.size > 1024 * 1024 * 50){
                    throw Error() 
                }
                formData.append('multipartFile', file as RcFile)
            })
        } catch (e) {
            setUploading(false)
            setFileList([...fileList])
            dispatch(requestFail('File Size Must limt 50M!'))
        }
        try {
            const res = await uploadFile(formData)
            setFileIds([...fileIds, ...res.map(item => item.id)])
            const resLen = res.length, fileListLen = fileListRef.current.length
            const _fileList = _.cloneDeep(fileListRef.current)
            for (let i = fileListLen - 1; i > (fileListLen - resLen) - 1; i--) {
                const resFile = res.pop()
                _fileList[i].url = `${UploadAPI}/onlinePreview?filePath=${resFile?.fullPath}`,
                _fileList[i].fileId = resFile?.id
                _fileList[i].status = 'done'
            }
            console.log('_fileList: ', _fileList)
            setFileList(_fileList)
            uploadFileLs.current = []
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
        setUploading(false)
    }
    const fn = debounce(() => {
        handleUpload(uploadFileLs.current)
    }, 1000)
    const props: UploadProps = {
        fileList,
        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: <Text className='txt_blue hand' title={t('downloadFile')}><DownloadOutlined style={{ fontSize: 16 }} /></Text>,
            removeIcon: <Text className='txt_red hand' title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
        },
        multiple: true,

        beforeUpload: file => {
            setUploading(true)
            console.log('beforeUpload', file)
            uploadFileLs.current.push(file)
            return false
        },
        onChange: info => {
            console.log('onChange: ', info)
            fileListRef.current = info.fileList
            const addList = info.fileList.filter(file => !('fileId' in file))
            addList.forEach(item => {
                item.status = 'uploading'
            })
            setFileList([...fileList, ...addList])
            fn()
        },
        onDownload: async (file: UploadFile & {
            url?: string
            fileId?: number
            status?: string
        }) => {
            try {
                if (file.fileId) {
                    file.status = 'uploading'
                    const findIndex = fileList.findIndex(item => item.fileId === file.fileId)
                    fileList.splice(findIndex, 1, file)
                    setFileList([...fileList])
                    const res = await getFile(file.fileId)
                    downloadFile(res, file.name)
                    file.status = 'done'
                    fileList.splice(findIndex, 1, file)
                    setFileList([...fileList])
                }
            } catch (error: any) {
                const str = getErrorStr(error)
                dispatch(requestFail(str))
            }
        },
        onRemove: async (file: UploadFile & {
            url?: string
            fileId?: number
            status?: string
        }) => {
            const index = fileList.findIndex(item => file.fileId === item.fileId)
            try {
                file.status = 'removed'
                const findIndex = fileList.findIndex(item => item.fileId === file.fileId)
                fileList.splice(findIndex, 1, file)
                setFileList([...fileList])
                await delFile(file.fileId as number)
                fileList.splice(index, 1)
                setFileList([...fileList])
                setFileIds(fileIds.filter(item => item !== file.fileId))
                return Promise.resolve()
            } catch (error: any) {
                file.status = 'error'
                const str = getErrorStr(error)
                dispatch(requestFail(str))
                return Promise.reject(error)
            }
        }
    }

    // 提案申请相关性反馈
    const onFinish = async (values: any) => {
        const description = editorRef.current?.serialize({ children: serialize(handleTrim(descriptionValue)) })
        const formData = {
            ...values,
            parentId: values.parentId ? Number(values.parentId) : undefined,
            // isCross: !!values.isCross,
            // isDisruptive: !!values.isDisruptive,
            isCross: values.technologyCertification === 2 ? true : undefined,
            isDisruptive: values.technologyCertification === 1 ? true : undefined,
            fileIds: values.fileIds || [],
            reviewDateHours: values.reviewDateHours ? [values.reviewDateHours[0]?.format('HH:mm'), values.reviewDateHours[1]?.format('HH:mm')].join('~') : '',
            description: JSON.stringify({
                str: description,
                obj: descriptionValue
            }),
            reviewDate: values.reviewDate.format('YYYY-MM-DD'),
            techIds: values.techProjects.map((item:any) => item.id) || []
        }
        console.log('onFinish: ', values, formData)
        // todo 测试
        // const flag = true
        // if(flag){
        //     return
        // }
        try {
            setLoading(true)
            if (!formObj || !formObj.id) {
                await addOnlineReview(formData).finally(() => {
                    setLoading(false)
                })
            } else {
                await editOnlineReview({
                    ...formObj,
                    ...formData,
                }).finally(() => {
                    setLoading(false)
                })
            }
            const args = {
                message: t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'),
                description: '',
                icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
                duration: 3,
            }
            notification.open(args)
            if (locationObj.key) {
                history.goBack()
            } else {
                history.replace('/indexPage')
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        console.log('onFinishFailed: ', errorFields, formRef.current?.getFieldsValue())
        // if (errorFields.length) {
        //     const args = {
        //         message: t('FinishFailed'),
        //         description: '',
        //         icon: <SmileOutlined style={{ color: '#e1931e' }} />,
        //         duration: 3,
        //     }
        //     notification.open(args)
        // }
    }
    const onReset = () => {
        formRef.current?.resetFields()
    }

    // 选择BU/CT清单后
    const selectBuCallback = (res: IBu[]) => {
        const ids = res.map(item => item.id)

        // const ids: IBu[] = []
        // const _userLs = [...res]
        // res.forEach(id => {
        //     const findIndex = _userLs.findIndex(user => user.id === id)
        //     if (findIndex !== -1) {
        //         ids.push(_userLs[findIndex])
        //         _userLs.splice(findIndex, 1)
        //     } else {
        //         const findObjOld = formObj?.dutyBuss?.find(item => item.id === id)
        //         // 找出原来已经加过的人，保留id
        //         if (findObjOld) {
        //             ids.push(findObjOld.id)
        //         } else {
        //             ids.push({
        //                 id: undefined,
        //                 tmtMail: item.email,
        //                 tmtUser: item.login,
        //                 nickName: item.nickName,
        //                 login: item.login
        //             })
        //         }
        //     }
        // })
        // // 选中人员再与原选择列表合并 并剔重
        // const unionArr = _userLs.concat(addLs)

        if (curSelectType === 'devSubject') {
            formRef.current?.setFieldValue('dutyBuss', ids)
            formRef.current?.validateFields(['dutyBuss'])
            setDevSubject(res)
        } else if (curSelectType === 'devCostAttr') {
            formRef.current?.setFieldValue('costBuss', ids)
            formRef.current?.validateFields(['costBuss'])
            setDevCostAttr(res)
        }
    }
    const selectBuCallback2 = (res: IBu[]) => {
        const ids = res.map(item => item.id)
        if (curSelectType === 'devSubject') {
            formRef.current?.setFieldValue('dutyBuss', ids)
            formRef.current?.validateFields(['dutyBuss'])
            setDevSubject(res)
        } else if (curSelectType === 'devCostAttr') {
            formRef.current?.setFieldValue('costBuss', ids)
            formRef.current?.validateFields(['costBuss'])
            setDevCostAttr(res)
        }
    }

    // 根据id获取申请详细信息 编辑初始化
    const getDetail = async (id: string, isSecond: boolean) => {
        try {
            const res = await getOnlineReviewById(+id)
            if (res) {
                // const fileIds = res.files.map(item => item.id)
                setloaded(true)
                const status = res.isDisruptive ? 1 : res.isCross ? 2 : 0
                const reviewDateHours = res.reviewDateHours?.includes('~')
                    ? res.reviewDateHours.split('~').map(item => moment(moment().format('YYYY-MM-DD') + ' ' + item))
                    : undefined
                // 获取评审会时间(+4个工作日起)
                const reviewDate = await getWorkDateFun()
                setFormObj({
                    parentId: isSecond ? id : undefined,
                    id: !isSecond ? res.id : undefined,
                    version: res.version,
                    fileIds: [],
                    workGroupId: res.workGroup.id,
                    workGroupName: res.workGroup.workGroupName,
                    roadMap: res.roadMap,
                    proposalName: res.proposalName,
                    subsidiary: res.subsidiary,
                    dueDate: moment(res.dueDate).format('YYYY-MM-DD'),
                    reviewDate,
                    tmtReviewDueDate: moment(res.tmtReviewDueDate).format('YYYY-MM-DD'),
                    reviewDateHours,
                    dutyBuss: res?.dutyBuss?.map(item => Number(item.id)) || [],
                    costBuss: res?.costBuss?.map(item => Number(item.id)) || [],
                    techProjects: res?.techProjects,
                    // isDisruptive: res.isDisruptive,
                    // isCross: res.isCross,
                    technologyCertification:status,
                    reviewType: res.reviewType,
                    techLevel: res.techLevel,
                    description: res.description,
                    isCommunicate: true
                })
                setDevSubject(res?.dutyBuss || [])
                setDevCostAttr(res?.costBuss || [])
                setIsCommunicate(true)
                dispatchR({ type: SetReviewType, payload: res.reviewType })
                dispatchR({
                    type: SetSelectTechList,
                    payload: res.parent?.techProjects || []
                })
                // setFileIds(fileIds)
                // setFileList(res.files.map(item => ({
                //     uid: '',
                //     name: item?.fileName,
                //     url: `${UploadAPI}/onlinePreview?filePath=${item?.filePath}`,
                //     fileId: item?.id,
                //     status: 'done'
                // })))
                if (res.description) {
                    setDescriptionValue(JSON.parse(res.description).obj)
                    // 富文本编辑器key
                    setEditorKey(getUuid(8))
                }
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 获取多少日个工作日后的日期
    const getWorkDateFun = async () => {
        const res = await getWorkDateDiff({
            startDay: moment().format('YYYYMMDD'),
            diffDay: 4
        })
        const m = moment(res)
        console.log('getWorkDateDiff: ', res, m)
        setSelectStartDate(m)

        setReviewDateKey(getUuid(8))
        return m
    }


    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techReviewProgress',
            breadcrumbName: t('technicalReviewProcess'),
        },
        {
            path: '/techReviewAdd',
            breadcrumbName: t('add') + (i18n.language !== 'zh' ? ' ' : '') + t('technicalReview'),
        },
    ])
    useEffect(() => {
        console.log('locationObj: ', locationObj)
        const curRoute = {
            path: '/techReviewAdd',
            breadcrumbName: t('technicalReview'),
        }
        if (locationObj.pathname.includes('Add')) {
            curRoute.breadcrumbName = t('add') + (i18n.language !== 'zh' ? ' ' : '') + curRoute.breadcrumbName
        } else if (locationObj.pathname.includes('Edit')) {
            curRoute.breadcrumbName = t('edit') + (i18n.language !== 'zh' ? ' ' : '') + curRoute.breadcrumbName
        } else if (locationObj.pathname.includes('More')) {
            curRoute.breadcrumbName = t('secondReview')
        }
        const routeParams = new URLSearchParams(location.search)
        const reviewId = routeParams.get('id')
        const type = routeParams.get('type')
        if (!reviewId) {
            setloaded(true)
        } else {
            getDetail(reviewId, locationObj.pathname.includes('More'))
        }
        if (type) {
            localStorage.setItem('curTab', type)
        }
        routes[1] = {
            path: '/techReviewProgress',
            breadcrumbName: approvalType[(Number(type) || 1) - 1].label
        }
        setRoutes([routes[0], routes[1], curRoute])
        // 富文本编辑器key
        setEditorKey(getUuid(8))
        if (!workgroupList.length) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }
    }, [])
    useEffect(() => {
        if (formObj) {
            form.setFieldsValue({
                ...formObj,
                dueDate: moment(formObj.dueDate)
            })
        }
    }, [formObj])

    useEffect(() => {
        formRef.current?.setFieldValue('fileIds', fileIds)
        formRef.current?.validateFields(['fileIds'])
    }, [fileIds])
    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                dispatch={dispatch}
            />
            {loaded ?
                <Form {...layout} ref={formRef}
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    className="edit_table"
                >
                    <Form.Item name="version" hidden><Input /></Form.Item>
                    <Form.Item name="id" hidden><Input /></Form.Item>
                    <Form.Item name="parentId" hidden><Input /></Form.Item>
                    <Form.Item name="reviewType" label={<span className='label'>{t('approval') + (i18n.language !== 'zh' ? ' ' : '') + t('type')}</span>}
                        rules={[{ required: true, message: t('approval Type Required') }]}
                    >
                        {approvalType.find(item => item.id === formObj?.reviewType)?.label || ''}
                    </Form.Item>
                    <Form.Item name="workGroupId" label={<span className='label'>{t('Work Group')}</span>}
                        rules={[{ required: true, message: t('Work Group Required') }]}
                    >
                        {formObj?.workGroupName || ''}
                    </Form.Item>
                    {isCommunicate && (<>
                        {reviewType !== 1 && (<>
                            {allSelectTechObj.map((techObj: any) => <Space direction="vertical" size={0} key={techObj.id}
                                className='form_item_mb'
                                style={{ width: '100%' }}
                            >
                                {/* 技术点信息 */}
                                <Form.Item label={<span className='label'>{t('tech') + (i18n.language !== 'zh' ? ' ' : '') + t('name')}</span>}>
                                    <div style={{ display: 'flex' }}>
                                        <div className='desc' dangerouslySetInnerHTML={{
                                            __html: techObj && techObj?.techName
                                                ? ((techObj.techName.includes('str') && techObj.techName.includes('obj')) ? JSON.parse(techObj.techName).str : techObj?.techName)
                                                : ''
                                        }}></div>
                                    </div>
                                </Form.Item>
                                <Form.Item label={<span className='label'>{t('subsidiary')}</span>}>
                                    {techObj && <>
                                        <Text>{ techObj.subsidiary }</Text>
                                    </>}
                                </Form.Item>
                                <Form.Item
                                    label={<span className='label'>{t('description')}</span>}
                                >
                                    <div className='desc' dangerouslySetInnerHTML={{
                                        __html: techObj && techObj?.description
                                            ? ((techObj.description.includes('str') && techObj.description.includes('obj')) ? JSON.parse(techObj.description).str : techObj?.description)
                                            : ''
                                    }}></div>
                                </Form.Item>
                                <Form.Item
                                    label={<span className='label'>{t('techLevel')}</span>}
                                >
                                    <span>{techObj && techObj?.techLevel
                                        ? [t('core'), t('key'), t('general'), t('normal')][(techObj?.techLevel as number || 1) - 1]
                                        : ''
                                    }</span>
                                </Form.Item>
                            </Space>)}
                        </>)}
                        <Form.Item name='proposalName'
                            label={<span className='label'>{t('technicalPlan') + (i18n.language !== 'zh' ? ' ' : '') + t('proposalName')}</span>}
                            rules={[{ required: true, message: t('proposalName Required') }]}
                        >
                            {formObj?.proposalName}
                        </Form.Item>
                        {formObj?.reviewType === 1 && <>
                            {/* <Form.Item name='isDisruptive'
                                label={<span className='label'>{t('isDisruptive')}</span>}
                                valuePropName="checked"
                            >
                                {formObj?.isDisruptive === null ? '' : (formObj?.isDisruptive ? '是' : '否')}
                            </Form.Item>
                            <Form.Item name='isCross'
                                label={<span className='label'>{t('isCross')}</span>}
                                valuePropName="checked"
                            >
                                {formObj?.isCross === null ? '' : (formObj?.isCross ? '是' : '否')}
                            </Form.Item> */}
                            <Form.Item name='technologyCertification'
                                label={<span className='label'>{t('technologyCertification')}</span>}
                            >
                                <Radio.Group disabled>
                                    <Radio value={1}>{t('isDisruptiveResult')}</Radio>
                                    <Radio value={2}>{t('isCrossResult')}</Radio>
                                    <Radio value={0}>{t('NotNeed')}</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </>}

                        <Form.Item name='reviewDate'
                            label={<span className='label'>{t('second') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('date')}</span>}
                            rules={[{ required: true, message: t('reviewMeeting Time Required') }]}
                        >
                            <Space align="center">
                                <Form.Item name='reviewDate' className='mb0'>
                                    <DatePicker allowClear key={reviewDateKey}
                                        locale={i18n.language === 'zh' ? locale : undefined}
                                        placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('time')}
                                        disabledDate={current => {
                                            if (!selectStartDate) {
                                                return current.isBefore(moment().format())
                                            } else {
                                                return current.isBefore(selectStartDate.format())
                                            }
                                        }}
                                        onChange={e => {
                                            formRef.current?.setFieldValue('reviewDate', e)
                                            formRef.current?.validateFields(['reviewDate'])
                                        }}
                                    />
                                </Form.Item>
                                <Text disabled>{t('timeZonePrompt')}</Text>
                            </Space>
                        </Form.Item>
                        <Form.Item name='reviewDateHours'
                            label={<span className='label'>{t('second') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('time')}</span>}
                            rules={[{ required: true, message: t('reviewMeeting Time Required') }]}
                        >
                            <Space align="center">
                                <Form.Item name='reviewDateHours' className='mb0'>
                                    <TimePicker.RangePicker allowClear
                                        format={'HH:mm'}
                                        minuteStep={10}
                                        locale={i18n.language === 'zh' ? locale : undefined}
                                        onChange={e => {
                                            console.log('reviewDateHours: ', e)
                                            if (e) {
                                                formRef.current?.setFieldValue('reviewDateHours', e)
                                                formRef.current?.validateFields(['reviewDateHours'])
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Space>
                        </Form.Item>
                        {formObj?.reviewType !== 1 && (<>
                            <Form.Item name='techProjects' style={ formObj?.techProjects && formObj.techProjects.length > 0 ? { marginBottom: 0 } : {}}
                                label={<span className='label'>{t('tech') + (i18n.language !== 'zh' ? ' ' : '') + t('list')}</span>}
                            >{formObj?.techProjects && formObj.techProjects.length > 0 ? '' : '无'}</Form.Item>
                            {formObj?.techProjects && formObj.techProjects.map((techObj: any) => (<Space direction="vertical" size={0} key={techObj.id}
                                className='form_item_mb'
                                style={{ width: '100%' }}
                            >
                                {/* 技术点信息 */}
                                <Form.Item label={<span className='label'>{t('tech') + (i18n.language !== 'zh' ? ' ' : '') + t('name')}</span>}>
                                    <div style={{ display: 'flex' }}>
                                        <div className='desc' dangerouslySetInnerHTML={{
                                            __html: (techObj?.techName && techObj.techName.includes('str') && techObj.techName.includes('obj'))
                                                ? JSON.parse(techObj.techName).str : ''
                                        }}></div>
                                    </div>
                                </Form.Item>
                                <Form.Item label={<span className='label'>{t('subsidiary')}</span>}>
                                    {techObj && <>
                                        <Text>{ techObj.subsidiary }</Text>
                                    </>}
                                </Form.Item>
                                <Form.Item
                                    label={<span className='label'>{t('description')}</span>}
                                >
                                    <div className='desc' dangerouslySetInnerHTML={{
                                        __html: (techObj?.description && techObj.description.includes('str') && techObj.description.includes('obj'))
                                            ? JSON.parse(techObj.description).str : ''
                                    }}></div>
                                </Form.Item>
                                <Form.Item
                                    label={<span className='label'>{t('techLevel')}</span>}
                                >
                                    <span>{
                                        [t('core'), t('key'), t('general'), t('normal')][(techObj?.techLevel as number || 1) - 1]
                                    }</span>
                                </Form.Item>
                            </Space>))}
                        </>)}
                        {formObj?.reviewType !== 3 && (<>
                            <Form.Item name='dutyBuss'
                                label={<span className='label'>{t('developDutySubject')}</span>}
                                rules={[
                                    {
                                        required: true,
                                        validator: async () => {
                                            if (!devSubject || devSubject.length === 0) {
                                                const helpStr = t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('developDutySubject')
                                                return Promise.reject(new Error(helpStr))
                                            } else {
                                                return Promise.resolve()
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Input hidden />
                                {devSubject.length > 0 && (<List style={{ marginBottom: 10, background: '#fff' }}
                                    bordered
                                    dataSource={devSubject}
                                    renderItem={(item, index) => <List.Item
                                        key={item.id}
                                        actions={[
                                            <Text className='txt_red hand' onClick={() => {
                                                devSubject.splice(index, 1)
                                                setDevSubject([...devSubject])
                                                formRef.current?.validateFields(['dutyBuss'])
                                            }} title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                        ]}
                                    >{item.bu}</List.Item>}
                                />)}
                                <Button
                                    onClick={() => {
                                        setCurSelectType('devSubject')
                                        setShowSelectBu(true)
                                    }}
                                >{t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}</Button>
                            </Form.Item>
                            <Form.Item name='costBuss'
                                label={<span className='label'>{t('developCostAttribute')}</span>}
                                rules={[
                                    {
                                        required: true,
                                        validator: async () => {
                                            if (!devCostAttr || devCostAttr.length === 0) {
                                                const helpStr = t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('developCostAttribute')
                                                return Promise.reject(new Error(helpStr))
                                            } else {
                                                return Promise.resolve()
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Input hidden />
                                {devCostAttr.length > 0 && (<List style={{ marginBottom: 10, background: '#fff' }}
                                    bordered
                                    dataSource={devCostAttr}
                                    renderItem={(item, index) => <List.Item
                                        key={item.id}
                                        actions={[
                                            <Text className='txt_red hand' onClick={() => {
                                                devCostAttr.splice(index, 1)
                                                setDevCostAttr([...devCostAttr])
                                                formRef.current?.validateFields(['costBuss'])
                                            }} title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                        ]}
                                    >{item.bu}</List.Item>}
                                />)}
                                <Button
                                    onClick={() => {
                                        setCurSelectType('devCostAttr')
                                        setShowSelectBu2(true)
                                    }}
                                >{t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}</Button>
                            </Form.Item>
                        </>)}
                        <Form.Item name='fileIds'
                            label={<span className='label'>{approvalType[(formObj?.reviewType || 1) - 1].label
                                + (i18n.language !== 'zh' ? ' ' : '') + t('attach')}</span>}
                            rules={[
                                {
                                    required: true,
                                    validator: async () => {
                                        if (fileIds.length === 0) {
                                            const helpStr = t('attach Required')
                                            return Promise.reject(new Error(helpStr))
                                        } else {
                                            return Promise.resolve()
                                        }
                                    }
                                }
                            ]}
                        >
                            <Input hidden />
                            <Upload {...props} disabled={uploading}>
                                <Button icon={<UploadOutlined />}
                                    loading={uploading}
                                >{t('uploadFile')}</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item name='description'
                            label={<span className='label'>{approvalType[(formObj?.reviewType || 1) - 1].label
                                + (i18n.language !== 'zh' ? ' ' : '') + t('description')}</span>}
                        >
                            <Input hidden />
                            <ConfigProvider
                                value={{
                                    ...defaultConfig,
                                    plugins: [
                                        ...Object.values({
                                            ...plugs
                                        }), 
                                    ],
                                }}
                            >
                                <DSlate ref={editorRef} key={editorKey} value={descriptionValue} onChange={setDescriptionValue} />
                            </ConfigProvider>
                        </Form.Item>
                        {formObj?.id && (<>
                            <Form.Item name='tmtReviewDueDate'
                                label={<span className='label'>{t('feedDueDate')}</span>}
                                valuePropName="checked"
                            >
                                {formObj?.tmtReviewDueDate}
                            </Form.Item>
                            <Form.Item name='dueDate'
                                label={<span className='label'>{t('feedEndDate')}</span>}
                                valuePropName="checked"
                            >
                                {formObj?.dueDate}
                            </Form.Item>
                        </>)}
                    </>)}
                    <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                        <Space size={20}>
                            <Button type="primary" htmlType="submit" loading={loading} disabled={!isCommunicate}>{t('submit')}</Button>
                            {!formObj && <Button htmlType="button" onClick={onReset}>{t('reset')}</Button>}
                        </Space>
                    </Form.Item>
                </Form>
                : (
                    <div 
                        style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    ><Spin size="large" /></div>
                )
            }
            <SelectBU show={showSelectBu} setShow={setShowSelectBu}
                title={t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}
                confirm={selectBuCallback} />
            <SelectBU show={showSelectBu2} setShow={setShowSelectBu2}
                title={t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')}
                confirm={selectBuCallback2} />
        </Space>
    )
}
export default ReviewMoreApply
